var poll_header_default = {
  "title": "An5aw",
  "image": "j1mDw",
  "webview": "wFjTO"
};
export {
  poll_header_default as default
};
//# sourceMappingURL=poll-header-scss.js.map
